import Vue from "vue";
import Vuex from "vuex";
import * as firebase from "firebase";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    loading: false,
    error: null,
    personal: {
      nume: null,
      prenume: null,
      cnp: null,
      judet: null,
      ciUrl: null,
      certUrl: null,
      hasCert: false
    },
    appeal: [
      {
        text: "",
        file: ""
      }
    ],
    users: {
      items: [],
      loading: false
    },
    faq: {
      items: [],
      allItems: [],
      loading: false
    },
    resources: {
      items: [],
      allItems: [],
      loading: false
    },
    allAplicants: []
  },
  getters: {
    user(state) {
      return state.user;
    },
    loading(state) {
      return state.loading;
    },
    error(state) {
      return state.error;
    },
    personal: state => state.personal,
    resources: state => state.resources,
    faq: state => state.faq,

    usersItems: state => state.users.items,
    usersLoading: state => state.users.loading,

    faqAllItems: state => state.faq.allItems,
    faqItems: state => state.faq.items,
    faqLoading: state => state.faq.loading,

    resourcesAllItems: state => state.resources.allItems,
    resourcesItems: state => state.resources.items,
    resourcesLoading: state => state.resources.loading,

    allAplicants: state => state.allAplicants,

    completedPersonal: state => {
      return (
        !!state.personal.nume &&
        !!state.personal.prenume &&
        !!state.personal.judet &&
        !!state.personal.cnp &&
        !!state.personal.hasCert &&
        !!state.personal.certUrl &&
        Array.isArray(state.personal.ciUrl) &&
        !!state.personal.ciUrl.length
      );
    }
  },
  mutations: {
    setLoadedForms(state, payload) {
      state.form = payload;
    },
    createForm(state, payload) {
      state.form.push(payload);
    },
    createAppeal(state, payload) {
      state.user.contestatii = payload;
    },
    personalDetails(state, payload) {
      // Vue.set(state, "personal", payload);
      state.personal = Object.assign(state.personal, payload)
    },
    setUser(state, payload) {
      state.user = payload;
    },
    setUserDetails(state, payload) {
      state.user.role = payload.role || "anonymous";
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setError(state, payload) {
      state.error = payload;
    },
    clearError(state) {
      state.error = null;
    },

    setUsersLoading(state, payload) {
      Vue.set(state.users, "loading", payload)
    },
    setUsers(state, payload) {
      Vue.set(state.users, "items", payload);
    },

    setFaqLoading(state, payload) {
      Vue.set(state.faq, "loading", payload);
    },
    setFaqAll(state, payload) {
      Vue.set(state.faq, "allItems", payload);
    },
    setFaq(state, payload) {
      Vue.set(state.faq, "items", payload);
    },

    setResourcesLoading(state, payload) {
      Vue.set(state.resources, "loading", payload);
    },
    setResources(state, payload) {
      Vue.set(state.resources, "items", payload);
    },
    setResourcesAll(state, payload) {
      Vue.set(state.resources, "allItems", payload);
    },

    setAllFaq(state, payload) {
      state.faq.allItems = payload;
    },
    setAllResources(state, payload) {
      state.resources.allItems = payload;
    },

    setAllAplicants(state, payload) {
      state.allAplicants = payload;
    }
  },
  actions: {
    async createPersonal({ state, commit, dispatch }, payload) {
      commit("setLoading", true);
      const personalDetails = {
        nume: payload.nume,
        prenume: payload.prenume,
        cnp: payload.cnp,
        judet: payload.judet,
        hasCert: payload.hasCert,
        ciUrl: payload.ciImage,
        certUrl: payload.certImage
      };

      if (payload.hasCert === false) {
        personalDetails.certUrl = null;
      }

      try {
        commit("personalDetails", {
          nume: null,
          prenume: null,
          cnp: null,
          judet: null,
          hasCert: false,
          ciUrl: null,
          certUrl: null
        });

        let ciUrl = [];
        let certUrl = [];
        const key = state.user.id;
        await savePersonalDetails(personalDetails, key, false);

        if (payload.ciFile) {
          let fileIndex = 0;
          for (const file of payload.ciFile) {
            const filename = file.name;
            const ext = filename.slice(filename.lastIndexOf(".") + 1);
            const fileID = `ci_${key}_${new Date().getTime()}.${ext}`;
            const ciFileData = await saveImage("personalDetails", file, key, "ci" + fileIndex, fileID);
            const cu = await ciFileData.ref.getDownloadURL();
            ciUrl.push(cu);
            fileIndex++;
          }
        }

        if (payload.certFile && payload.hasCert) {
          let fileIndex = 0;
          for (const file of payload.certFile) {
            const filename = file.name;
            const ext = filename.slice(filename.lastIndexOf(".") + 1);
            const fileID = `cert_${key}_${new Date().getTime()}.${ext}`;
            const certFileData = await saveImage("personalDetails", file, key, "cert" + fileIndex, fileID);
            const cu = await certFileData.ref.getDownloadURL();
            certUrl.push(cu);
            fileIndex++;
          }
        }

        if (ciUrl.length) {
          firebase
            .database()
            .ref("personalDetails")
            .child(key)
            .update({ ciUrl });
          firebase
            .database()
            .ref("users")
            .child(key)
            .update({ ciUrl });
        }

        if (certUrl.length) {
          firebase
            .database()
            .ref("personalDetails")
            .child(key)
            .update({ certUrl });
          firebase
            .database()
            .ref("users")
            .child(key)
            .update({ certUrl });
        }

        dispatch("getPersonalDetails");
      } catch (err) {
        console.log(err);
      } finally {
        commit("setLoading", false);
      }
    },
    async createAppeal({ state, commit }, payload) {
      try {
        // upload file, if any

        let url = null;
        if (payload.file) {
          const file = payload.file;
          const filename = file.name;
          const ext = filename.slice(filename.lastIndexOf(".") + 1);
          const fileID = `contestatie_${state.user.id}_${new Date().getTime()}.${ext}`;
          const fileData = await saveImage("contestatii", file, state.user.id, "contestatie", fileID);
          url = await fileData.ref.getDownloadURL();
        }

        // update users
        /* eslint-disable no-unused-vars */
        const updateData = {
          text: payload.text,
          file: url,
          data: new Date()
        };
        /* eslint-disable no-unused-vars */
        const key = firebase
          .database()
          .ref(`users/${state.user.id}/contestatii/`)
          .push().key;

        firebase
          .database()
          .ref(`users/${state.user.id}/contestatii/${key}`)
          .update(updateData);

        commit("createAppeal", true);
      } catch (err) {
        console.log(err);
      }
    },
    async autoSignIn({ commit, dispatch }) {
      /* eslint-disable no-unused-vars */
      return new Promise((resolve, reject) => {
        firebase.auth().onAuthStateChanged(user => {
          if (user) {
            const id = user.uid;
            dispatch("getPersonalDetails", id);
            firebase
              .database()
              .ref("users")
              .child(id)
              .once("value")
              .then(result => {
                const details = result.val();
                if (details) {
                  commit("setUser", {
                    email: details.email,
                    verified: user.emailVerified,
                    id,
                    role: details.role,
                    contestatii: details.contestatii,
                    comisie: details.comisie,
                    nrcrt: details.nrcrt,
                    deactivated: details.deactivated || false
                  });
                }
                resolve();
              });
          } else {
            resolve();
          }
        });
      });
    },
    forgotPassword({ commit }, payload) {
      commit("clearError");
      firebase
        .auth()
        .sendPasswordResetEmail(payload.email)
        .then(() => {
          commit("setError", {
            message:
              "Email-ul a fost trimis. Va rugam sa verificati inclusiv dosarele spam/junk."
          });
        })
        .catch(error => {
          console.log(error)
          if (error.code === "auth/user-not-found") {
            commit("setError", {
              message:
                "Adresa de email furnizata nu figureaza in baza noastra de date."
            });
          } else {
            commit("setError", {
              message: "Ne pare rau, am intampinat o eroare..."
            });
          }
        });
    },
    signOut({ commit }) {
      firebase.auth().signOut();
      commit("setUser", null);
      commit("personalDetails", {
        nume: null,
        prenume: null,
        cnp: null,
        judet: null,
        ciUrl: null,
        certUrl: null,
        hasCert: false
      });
    },
    async signUserUp({ commit }, payload) {
      commit("setLoading", true);
      commit("clearError");
      let result;

      try {
        result = await firebase
          .auth()
          .createUserWithEmailAndPassword(payload.email, payload.password);

        await savePersonalDetails(
          {
            role: "aplicant",
            created: result.user.metadata.creationTime,
            email: payload.email
          },
          result.user.uid,
          true
        );

        result.user.sendEmailVerification();

        const detailsResult = await firebase
          .database()
          .ref("users")
          .child(result.user.uid)
          .once("value");

        const details = detailsResult.val();

        commit("setUser", {
          id: result.user.uid,
          role: "aplicant",
          email: payload.email,
          verified: result.user.emailVerified,
          nrcrt: details.nrcrt
        });
      } catch (e) {
        commit("setLoading", false);
        if (e.code === "auth/email-already-in-use") {
          e.message = "Exista deja un cont asociat acestei adrese de email.";
        }
        commit("setError", e);
        console.log(e);
      } finally {
        commit("setLoading", false);
      }
    },
    async signUserIn({ commit, dispatch }, payload) {
      commit("setLoading", true);
      commit("clearError");

      try {
        const result = await firebase
          .auth()
          .signInWithEmailAndPassword(payload.email, payload.password);

        const detailsResult = await firebase
          .database()
          .ref("users")
          .child(result.user.uid)
          .once("value");

        const details = detailsResult.val();

        commit("setUser", {
          email: details.email,
          verified: result.user.emailVerified,
          deactivated: details.deactivated || false,
          id: result.user.uid,
          role: details.role,
          contestatii: details.contestatii,
          comisie: details.comisie,
          nrcrt: details.nrcrt
        });

        dispatch("getPersonalDetails", result.user.id);
      } catch (e) {
        console.log(e)
        if (e.code === "auth/wrong-password") {
          e.message = "Parola introdusa de dumneavoastra este invalida.";
        }
        if (e.code === "auth/user-not-found") {
          e.message = "Utilizator inexistent.";
        }
        commit("setError", e);
      } finally {
        commit("setLoading", false);
      }
    },
    clearError({ commit }) {
      commit("clearError");
    },
    getPersonalDetails({ state, commit }, payload) {
      firebase
        .database()
        .ref("personalDetails")
        .child(state.user?.id ?? payload)
        .once("value")
        .then(data => {
          const obj = data.val();
          commit("personalDetails", obj);
        });
    },

    fetchDraft({ state }) {
      return firebase
        .database()
        .ref("forms")
        .child(state.user.id)
        .once("value")
        .then(data => {
          return data.val();
        });
    },
    async saveForm({ state, commit }, payload) {
      commit("setLoading", true);

      try {
        const key = state.user.id;
        await saveForm(payload, key);
      } catch (err) {
        console.log(err);
      } finally {
        commit("setLoading", false);
      }
    },
    removeFile({ state }, payload) {
      const key = state.user.id;

      firebase
        .database()
        .ref("forms")
        .child(key)
        .update({ [`step${payload.step}`]: payload.remaining });

      firebase
        .storage()
        .ref("forms")
        .child(payload.fileID)
        .delete();
    },

    async deleteUser({ dispatch }, payload) {
      // await firebase
      //   .database()
      //   .ref("users")
      //   .child(payload)
      //   .remove();

      // await firebase
      //   .database()
      //   .ref("personalDetails")
      //   .child(payload)
      //   .remove();

      await firebase
        .database()
        .ref("users")
        .child(payload.id)
        .update({
          deactivated: payload.value
        });

      await firebase
        .database()
        .ref("personalDetails")
        .child(payload.id)
        .update({
          deactivated: payload.value
        });

      dispatch("fetchUsers");
    },
    async fetchUsers({ state, commit }) {
      try {
        commit("setUsersLoading", true);
        const usersResponse = await firebase
          .database()
          .ref("users")
          .once("value");
        const usersObject = usersResponse.val();
        if (usersObject) {
          const users = Object.keys(usersObject).map(key => {
            return {
              id: key,
              ...usersObject[key]
            }
          });
          commit("setUsers", users);
        } else {
          commit("setUsers", []);
        }
      } catch (err) {
        console.log(err);
      } finally {
        commit("setUsersLoading", false);
      }
    },
    async saveUser({ commit, dispatch }, payload) {
      commit("setUsersLoading", true);
      if (payload.id) { //update
        const id = payload.id;
        delete payload.id;
        delete payload.email;
        delete payload.password;

        await savePersonalDetails(payload, id, false);
        commit("setUsersLoading", false);
        dispatch("fetchUsers");
      } else { // create
        try {
          const email = payload.email;
          const password = payload.password;

          delete payload.id;
          delete payload.email;
          delete payload.password;

          const currentUser = firebase.auth().currentUser;
          const aiNumber = await aiRead();
          const result = await firebase
            .auth()
            .createUserWithEmailAndPassword(email, password);
          firebase.auth().updateCurrentUser(currentUser);

          await savePersonalDetails({
            ...payload,
            email,
            created: result.user.metadata.creationTime
            },
            result.user.uid,
            true
          );

          result.user.sendEmailVerification();
        } catch (err) {
          console.log(err);
        } finally {
          commit("setUsersLoading", false);
          dispatch("fetchUsers");
        }
      }
    },

    async loadUserForm({ commit }, payload) {
      commit("setUsersLoading", true);
      try {
        const form = await firebase
          .database()
          .ref("forms")
          .child(payload)
          .once("value");

        return form.val();
      } catch (err) {
        return {
          eroare: "Ne pare rau, a intervenit o eroare in procesarea cererii."
        };
      } finally {
        commit("setUsersLoading", false);
      }
    },

    async loadUserPersonal({ commit }, payload) {
      commit("setUsersLoading", true);
      try {
        const form = await firebase
          .database()
          .ref("personalDetails")
          .child(payload)
          .once("value");

        return form.val();
      } catch (err) {
        return {
          eroare: "Ne pare rau, a intervenit o eroare in procesarea cererii."
        };
      } finally {
        commit("setUsersLoading", false);
      }
    },

    async fetchFaq({ state, commit }) {
      try {
        commit("setFaqLoading", true);

        const faqResponse = await firebase
          .database()
          .ref("faq")
          .once("value");
        const faqObject = faqResponse.val();

        if (faqObject) {
          const faq = Object.keys(faqObject).map(key => {
            return {
              id: key,
              ...faqObject[key]
            }
          });
          commit("setFaq", faq);
        } else {
          commit("setFaq", []);
        }
      } catch (err) {
        console.log(err);
      } finally {
        commit("setFaqLoading", false);
      }
    },
    async saveFaq({ commit, dispatch }, payload) {
      try {
        commit("setFaqLoading", true);

        let id = null;
        if (payload.id) { // update
          id = payload.id;
        } else { // create
          id = await firebase
            .database()
            .ref("faq")
            .push().key;
        }

        delete payload.id;

        await firebase
          .database()
          .ref(`faq/${id}`)
          .update(payload);

        return true;
      } catch (err) {
        console.log(err);
        return false;
      } finally {
        commit("setFaqLoading", false);
        dispatch("fetchFaq");
      }
    },
    async deleteFaq({ dispatch }, payload) {
      await firebase
        .database()
        .ref("faq")
        .child(payload)
        .remove();

      dispatch("fetchFaq");
    },

    async fetchResources({ state, commit }) {
      try {
        commit("setResourcesLoading", true);

        const resourcesResponse = await firebase
          .database()
          .ref("resources")
          .once("value");
        const resourcesObject = resourcesResponse.val();

        if (resourcesObject) {
          const resources = Object.keys(resourcesObject).map(key => {
            return {
              id: key,
              ...resourcesObject[key]
            }
          });
          commit("setResources", resources);
        } else {
          commit("setResources", []);
        }
      } catch (err) {
        console.log(err);
      } finally {
        commit("setResourcesLoading", false);
      }
    },
    async saveResource({ commit, dispatch }, payload) {
      // payload.fileBuffer and payload.thumbBuffer

      try {
        commit("setResourcesLoading", true);

        let id = null;
        if (payload.id) { // update
          id = payload.id;
        } else { // create
          id = await firebase
            .database()
            .ref("resources")
            .push().key;
        }

        let fileUrl = null;
        let thumbUrl = null;

        if (payload.fileBuffer) {
          const filename = payload.fileBuffer.name;
          const ext = filename.slice(filename.lastIndexOf(".") + 1);
          const fileID = `file_${id}_${new Date().getTime()}.${ext}`;
          const fileData = await saveImage("resources", payload.fileBuffer, id, "file", fileID);
          fileUrl = await fileData.ref.getDownloadURL();
        }
        if (payload.thumbBuffer) {
          const filename = payload.thumbBuffer.name;
          const ext = filename.slice(filename.lastIndexOf(".") + 1);
          const thumbID = `thumb_${id}_${new Date().getTime()}.${ext}`;
          const thumbData = await saveImage("resources", payload.thumbBuffer, id, "thumb", thumbID);
          thumbUrl = await thumbData.ref.getDownloadURL();
        }

        delete payload.id;

        await firebase
          .database()
          .ref(`resources/${id}`)
          .update({
            title: payload.title,
            content: payload.content,
            index: payload.index
          });

        if (fileUrl) {
          await firebase
            .database()
            .ref(`resources/${id}`)
            .update({
              file: fileUrl
            });
        }

        if (thumbUrl) {
          await firebase
            .database()
            .ref(`resources/${id}`)
            .update({
              thumb: thumbUrl
            });
        }

        return true;
      } catch (err) {
        console.log(err);
        return false;
      } finally {
        commit("setResourcesLoading", false);
        dispatch("fetchResources");
      }
    },
    async deleteResource({ dispatch }, payload) {
      await firebase
        .database()
        .ref("resources")
        .child(payload)
        .remove();

      dispatch("fetchResources");
    },

    async fetchAllFaq({ commit }) {
      const faqResponse = await firebase
        .database()
        .ref("faq")
        .once("value");
      const faqObject = faqResponse.val();
      if (faqObject) {
        const faq = Object.keys(faqObject).map(key => {
          return {
            id: key,
            ...faqObject[key]
          }
        });
        faq.sort((a, b) => a.index - b.index);
        commit("setAllFaq", faq);
      }
    },
    async fetchAllResources({ commit }) {
      const resourcesResponse = await firebase
        .database()
        .ref("resources")
        .once("value");
      const resourcesObject = resourcesResponse.val();
      if (resourcesObject) {
        const resources = Object.keys(resourcesObject).map(key => {
          return {
            id: key,
            ...resourcesObject[key]
          }
        });
        resources.sort((a, b) => a.index - b.index);
        commit("setAllResources", resources);
      }
    },
    // FIREBASE WARNING: Using an unspecified index.
    // Your data will be downloaded and filtered on the client.
    // Consider adding ".indexOn": "role" at /users to your security rules for better performance.
    async fetchAllAplicants({ commit, dispatch }) {
      commit("setLoading", true);
      const usersResponse = await firebase
        .database()
        .ref("users")
        .orderByChild("role")
        .equalTo("aplicant")
        .once("value");
      // testing purposes: just comment the filter
      const usersObject = usersResponse.val();
      if (usersObject) {
        const users = Object.keys(usersObject).map(key => {
          return {
            id: key,
            ...usersObject[key]
          };
        })
        .filter(user => !user.deactivated);

        for (const user of users) {
          user.form = await dispatch("fetchAplicantForm", user.id);
        }

        commit("setAllAplicants", users);
        commit("setLoading", false);
      }
    },

    /* eslint-disable no-unused-vars */
    async fetchAplicantForm({ state }, payload) {
      return firebase
        .database()
        .ref("forms")
        .child(payload)
        .once("value")
        .then(data => {
          return data.val();
        });
    },

    async saveEvaluation({ state, dispatch }, payload) {
      const id = payload.id;
      const grila = payload.grilaFile;
      delete payload.grilaFile;
      delete payload.id;
      payload = {
        ...payload,
        evaluator: `${state.personal.nume} ${state.personal.prenume}`,
        data: new Date()
      };

      if (grila) {
        // upload file and get download url
        const filename = grila.name;
        const ext = filename.slice(filename.lastIndexOf(".") + 1);
        const fileID = `grila_${payload.evaluator.replace(/ /g, "_")}_${new Date().getTime()}.${ext}`;
        const fileData = await saveImage("grileEvaluare", grila, null, null, fileID);
        const grilaUrl = await fileData.ref.getDownloadURL();
        payload.grila = grilaUrl;
      }

      await firebase
        .database()
        .ref(`users/${id}/evaluare/${state.user.id}`)
        .update(payload);
      dispatch("fetchAllAplicants");
    },

    /* eslint-disable no-unused-vars */
    async openForm({ state }, payload) {
      return firebase
        .database()
        .ref(`forms/${payload}`)
        .update({ draft: true });
    },

    async resendEmail() {
      return firebase.auth().currentUser.sendEmailVerification();
    }
  },
  modules: {}
});

async function saveForm(payload, id) {
  // upload any new files
  //  step1: cerere, declaratie, cazierjudiciar, cazierfiscal, cv
  //  step2: file
  //  step4: xls, pdf
  //  step5: file
  //  step6: file

  if (payload.step1.cerere.file) {
    payload.step1.cerere.url = await saveFile(payload.step1.cerere.file, `${id}_pasul1_cerere_`);
    payload.step1.cerere.saved = true;
    payload.step1.cerere.file = null;
  }
  if (payload.step1.declaratie.file) {
    payload.step1.declaratie.url = await saveFile(payload.step1.declaratie.file, `${id}_pasul1_declaratie_`);
    payload.step1.declaratie.saved = true;
    payload.step1.declaratie.file = null;
  }
  if (payload.step1.cazierjudiciar.file) {
    payload.step1.cazierjudiciar.url = await saveFile(payload.step1.cazierjudiciar.file, `${id}_pasul1_cazierjudiciar_`);
    payload.step1.cazierjudiciar.saved = true;
    payload.step1.cazierjudiciar.file = null;
  }
  if (payload.step1.cazierfiscal.file) {
    payload.step1.cazierfiscal.url = await saveFile(payload.step1.cazierfiscal.file, `${id}_pasul1_cazierfiscal_`);
    payload.step1.cazierfiscal.saved = true;
    payload.step1.cazierfiscal.file = null;
  }
  if (payload.step1.cv.file) {
    payload.step1.cv.url = await saveFile(payload.step1.cv.file, `${id}_pasul1_cv_`);
    payload.step1.cv.saved = true;
    payload.step1.cv.file = null;
  }

  if (payload.step2.file.file) {
    payload.step2.file.url = await saveFile(payload.step2.file.file, `${id}_pasul2_file_`);
    payload.step2.file.saved = true;
    payload.step2.file.file = null;
  }

  if (payload.step4.xls.file) {
    payload.step4.xls.url = await saveFile(payload.step4.xls.file, `${id}_pasul4_xls_`);
    payload.step4.xls.saved = true;
    payload.step4.xls.file = null;
  }
  if (payload.step4.pdf.file) {
    payload.step4.pdf.url = await saveFile(payload.step4.pdf.file, `${id}_pasul4_pdf_`);
    payload.step4.pdf.saved = true;
    payload.step4.pdf.file = null;
  }

  if (payload.step5.file.file) {
    payload.step5.file.url = await saveFile(payload.step5.file.file, `${id}_pasul5_file_`);
    payload.step5.file.saved = true;
    payload.step5.file.file = null;
  }

  if (payload.step6.file.file) {
    payload.step6.file.url = await saveFile(payload.step6.file.file, `${id}_pasul6_file_`);
    payload.step6.file.saved = true;
    payload.step6.file.file = null;
  }

  if (payload.step6.anotherfile.file) {
    payload.step6.anotherfile.url = await saveFile(payload.step6.anotherfile.file, `${id}_pasul6_anotherfile_`);
    payload.step6.anotherfile.saved = true;
    payload.step6.anotherfile.file = null;
  }

  // save form data
  return firebase
    .database()
    .ref(`forms/${id}`)
    .update(payload);
}

async function savePersonalDetails(payload, id, newUser) {
  if (newUser) {
    const aiNumber = await aiRead();

    await firebase
      .database()
      .ref(`users/${id}`)
      .update({
        ...payload,
        nrcrt: aiNumber
      });

    await firebase
      .database()
      .ref(`personalDetails/${id}`)
      .update({
        ...payload,
        nrcrt: aiNumber
      });

    return aiUpdate(aiNumber + 1);
  } else {
    await firebase
      .database()
      .ref(`users/${id}`)
      .update({
        ...payload
      });

    return firebase
      .database()
      .ref(`personalDetails/${id}`)
      .update({
        ...payload
      });
  }
}

function saveImage(collection, file, key, which, fileID) {
  return firebase
    .storage()
    .ref(collection)
    .child(fileID)
    .put(file);
}

async function aiRead() {
  const resp = await firebase
    .database()
    .ref("autoincrement/users")
    .once("value");
  const val = resp.val();

  return val?.count ?? null;
}

function aiUpdate(count) {
  return firebase
    .database()
    .ref(`autoincrement/users`)
    .update({ count });
}

async function saveFile(file, label) {
  const filename = file.name;
  const ext = filename.slice(filename.lastIndexOf(".") + 1);
  const fileID = `${label}.${ext}`;
  const fileData = await firebase
    .storage()
    .ref("forms")
    .child(fileID)
    .put(file);
  const url = await fileData.ref.getDownloadURL();

  return url;
}
